<template>
  <section>
    <p class="title is-2">Historial de movimientos</p>
    <div class="field is-grouped">
      <p class="control">
        <b-select v-model="perPage">
          <option value="5">5 por página</option>
          <option value="10">10 por página</option>
          <option value="20">20 por página</option>
          <option value="30">30 por página</option>
          <option value="50">50 por página</option>
          <option value="100">100 por página</option>
        </b-select>
      </p>
    </div>
    <busqueda-en-fecha @seleccionada="onBusquedaEnFecha" />

    <b-table
      :data="movimientos"
      :paginated="isPaginated"
      :per-page="perPage"
      :bordered="true"
      :striped="true"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :pagination-rounded="isPaginationRounded"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
      <b-table-column
        field="producto"
        label="Nombre"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.producto }}
      </b-table-column>

      <b-table-column
        field="cantidadAntes"
        label="Antes"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.cantidadAntes }}
      </b-table-column>

      <b-table-column
        field="cantidadDespues"
        label="Despues"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.cantidadDespues }}
      </b-table-column>

      <b-table-column
        field="usuario"
        label="Usuario"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.usuario }}
      </b-table-column>
      <b-table-column
        field="tipoMovimiento"
        label="Tipo Movimiento"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.tipoMovimiento }}
      </b-table-column>
      <b-table-column
        field="fecha"
        label="Fecha y hora Movimiento"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.fecha }}
      </b-table-column>


    </b-table>
    <b-loading
      :is-full-page="true"
      v-model="cargando"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>
<script>
import HttpService from "../../Servicios/HttpService";
import BusquedaEnFecha from "../Extras/BusquedaEnFecha";

export default {
  components: {
    BusquedaEnFecha,
  },
  data: () => ({
    cargando: false,
    movimientos: [],
    isPaginated: true,
    isPaginationSimple: false,
    isPaginationRounded: true,
    paginationPosition: "bottom",
    defaultSortDirection: "asc",
    sortIcon: "arrow-up",
    sortIconSize: "is-small",
    currentPage: 1,
    perPage: 5,
    filtros: {
      fechaInicio: "",
      fechaFin: "",
    },
  }),

  mounted() {
    this.historialMovimientos();
    document.title = "Movimientos";
  },

  methods: {
    historialMovimientos() {
      // Método para obtener la lista de historialMovimientos
      let payload = {
        accion: "historialMovimientos",
      };

      HttpService.obtenerConConsultas("vender.php", payload).then(
        (movimientos) => {
          this.movimientos = movimientos;
        }
      );
    },
    onBusquedaEnFecha(fechas) {
      // Establecer la fecha de inicio con la hora constante a las 05:00:00 en UTC
      const fechaInicio = new Date(fechas[0]);
      fechaInicio.setUTCHours(5, 0, 0, 0); // Establecer la hora a las 05:00:00 en UTC
      // Formatear la fecha y hora como cadena "YYYY-MM-DD HH:mm:ss"
      const fechaInicioString =
        fechaInicio.toISOString().split("T")[0] + " 05:00:00";
      this.filtros.fechaInicio = fechaInicioString;
      // Establecer la fecha de fin con la hora constante a las 05:00:00 en UTC
      const fechaFin = new Date(fechas[1]);
      fechaFin.setUTCHours(5, 0, 0, 0); // Establecer la hora a las 05:00:00 en UTC
      // Sumar un día a la fecha fin
      fechaFin.setUTCDate(fechaFin.getUTCDate() + 1);
      // Formatear la fecha y hora como cadena "YYYY-MM-DD HH:mm:ss"
      const fechaFinString = fechaFin.toISOString().split("T")[0] + " 05:00:00";
      this.filtros.fechaFin = fechaFinString;
      this.obtenerHistorial();
    },
  },
};
</script>